<template>
  <div>
    <h1 class="outline--text">Sources and Geolocation</h1>
    <br />

    <v-card>
      <v-row class="mb-4" dense>
        <v-card-title>
          <v-text-field
            v-model="filters.domain"
            label="Domain"
            clearable
          ></v-text-field>
        </v-card-title>

        <v-card-title>
          <v-btn color="primary" class="mr-2" @click="fetchSourceGeo">
            Apply Filters
          </v-btn>
          <v-btn text @click="resetFilters"> Reset </v-btn>
        </v-card-title>
        <v-card-title v-if="canManage">
          <v-btn
            depressed
            rounded
            small
            outlined
            icon
            color="grey darken-1"
            style="float: right"
            class="my-5"
            @click="exportItems"
            ><v-icon> mdi-file-export-outline </v-icon></v-btn
          >
        </v-card-title>
      </v-row>

      <!-- Data loader -->
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        class="my-3"
      ></v-progress-linear>

      <v-data-table
        :headers="headers"
        :items="sourceGeo"
        :search="search"
        :loading="isLoading"
        :no-data-text="isLoading ? 'Loading items...' : 'No Source Geo found'"
        class="elevation-1"
      >
        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            color="blue"
            class="mr-2"
            @click="openUpdateDialog(item)"
            title="Update"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="showError" color="error" timeout="5000">
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showError = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_SOURCE_GEO,
  FETCH_SOURCE_GEO_FILE,
} from "@/store/modules/sourceGeo/actions";
import { RESOURCE_SOURCE_RATING_MANAGEMENT } from "@/store/modules/admin/getters";
import acl from "@/mixin/acl";
import sourceGeo from "@/store/modules/sourceGeo";

export default {
  name: "SourceGeoPage",
  mixins: [acl],
  data() {
    return {
      search: "",
      showError: false,
      filters: {
        domain: "",
      },
      headers: [
        { text: "Domain", value: "main_domain" },
        { text: "Country", value: "country_iso" },
        { text: "Last Updated", value: "updated_at" },
      ],
      dialog: false,
    };
  },
  computed: {
    sourceGeo() {
      return sourceGeo;
    },
    ...mapGetters("sourceGeo", ["sourceGeo", "isLoading", "hasError", "error"]),
    canManage: function () {
      return this.hasAccess([RESOURCE_SOURCE_RATING_MANAGEMENT]);
    },
  },
  methods: {
    fetchSourceGeo() {
      const params = {
        domain: this.filters.domain || undefined,
        search: this.search || undefined,
      };

      Object.keys(params).forEach((key) => {
        if (
          params[key] === undefined ||
          params[key] === null ||
          params[key] === ""
        ) {
          delete params[key];
        }
      });

      this.$store
        .dispatch(`sourceGeo/${FETCH_SOURCE_GEO}`, { params })
        .catch((error) => {
          console.error("Error fetching Source Geo:", error);
          this.showError = true;
        });
    },
    exportItems() {
      const params = {
        domain: this.filters.domain,
        search: this.search,
      };
      Object.keys(params).forEach(
        (k) => (params[k] == null || params[k] === "") && delete params[k]
      );

      this.$store
        .dispatch(`sourceGeo/${FETCH_SOURCE_GEO_FILE}`, params)
        .catch((error) => {
          console.error("Error exporting Source Ratings:", error);
          this.showError = true;
        });
    },
    resetFilters() {
      this.filters.domain = "";
      this.search = "";
      this.fetchSourceGeo();
    },
  },
  mounted() {
    this.fetchSourceGeo();
  },
  watch: {
    error(newVal) {
      if (newVal) {
        this.showError = true;
      }
    },
  },
};
</script>
